import React, { memo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SET_SELECTED_FILTER } from 'estimate_list/reducers/initial'
import FilterColumn from './filter_column'
import { filterTheorem } from 'estimate_list/libs/util'

const FilterSpec = ({ specData }) => {
    const selectedFilters = useSelector(state => state.initial.selectedFilters)

    const dispatch = useDispatch()

    const onClickSpec = useCallback(spec => () => {
        // ex) specNameKey:37, specValueKey: 12345, specValue: '상품분류 : 인텔 CPU용'
        const { specNameKey, specValueKey, specValue } = spec
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'spec',
                value: { specNameKey, specValueKey, specValue }
            })
        })
    }, [dispatch, selectedFilters])

    const active = useCallback(({ specNameKey, specValueKey }) => {
        const selectNameKey = selectedFilters.spec[specNameKey]
        if (selectNameKey) {
            const index = selectNameKey.findIndex(v => v.specValueKey === specValueKey)
            return index > -1
        }
    }, [selectedFilters.spec])

    return (
        <FilterColumn title={specData.spec_name}>
            <div className="row">
                {specData.spec_sel_default?.length > 0 && (
                    <ul className="title_list">
                        {specData.spec_sel_default.map(v => (
                            <li key={v.pr_idx} className={`${active({specNameKey: specData.pr_idx, specValueKey: v.pr_idx}) ? 'active' : ''}`}>
                                <button type="button" onClick={onClickSpec({specNameKey: specData.pr_idx, specValueKey: v.pr_idx, specValue: specData.spec_name +' : '+ v.spec_sel})}>
                                    <span className="text">{v.spec_sel}</span>
                                    <i className="icon-close" />
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
                <div className="cell">
                    <ul className="list">
                        {specData.spec_sel.map(v => (
                            <li key={v.pr_idx} className={`${active({specNameKey: specData.pr_idx, specValueKey: v.pr_idx}) ? 'active' : ''}`}>
                                <button type="button" onClick={onClickSpec({specNameKey: specData.pr_idx, specValueKey: v.pr_idx, specValue: specData.spec_name +' : '+ v.spec_sel})}>
                                    <span className="text">{v.spec_sel}</span>
                                    <i className="icon-close" />
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </FilterColumn>
    )
}

export default memo(FilterSpec)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_spec.js